/**
 * Carbon small loading indicator: a ring with a turning arc in the current
 * text color. With `label` it is a polite live region a screen reader
 * announces; without one it is decorative (inside a busy button, say).
 * prefers-reduced-motion stops the turn (index.css).
 */
import clsx from 'clsx'

export interface SpinnerProps {
  size?: 16 | 20
  /** Announced text ("Loading drifts"). Omit when the context already says it. */
  label?: string
  className?: string
}

export function Spinner({ size = 16, label, className }: SpinnerProps) {
  const ring = (
    <svg
      viewBox="0 0 16 16"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
      focusable="false"
      className={clsx('flex-none animate-spin', !label && className)}
    >
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeOpacity={0.25} strokeWidth={1.5} />
      <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth={1.5} strokeDasharray="30 41" />
    </svg>
  )
  if (!label) return ring
  return (
    <span role="status" className={clsx('inline-flex items-center', className)}>
      {ring}
      <span className="sr-only">{label}</span>
    </span>
  )
}

export default Spinner
